export enum WebThemes {
  BASIC = 'basic',
}

export enum ResumeThemes {
  BASIC = 'basic',
}
